const FAQs = () => {
    return (
        <section className="same_space pt-0">
            <div className="container">
                <div className="faq_hedding">
                    <h2>FAQs</h2>
                </div>
                <div className="faq_wepper">
                    <div className="faq_inner">
                        <h3>In a hurry? We can help.</h3>
                        <p>Our office is open from 8:00 AM to 7:00 PM</p>

                        <hr />
                    </div>
                    <div className="faq_inner">
                        <h3>Do you offer financing options?</h3>
                        <p>As HVAC experts, we, at Sparks Heating and Air, understand that installing or replacing HVAC
                            systems in your home is hefty on your budget. We offer multiple flexible financing options. To
                            know more about the financing options, contact us and talk with our financing experts who will
                            answer all your queries and doubts.</p>
                        <hr />
                    </div>
                    <div className="faq_inner">
                        <h3>Do you service all manufacturers and brands? </h3>
                        <p>Sparks Heating and Air is able to service most makes and models of HVAC equipment</p>
                        <hr />
                    </div>
                    <div className="faq_inner">
                        <h3>How often should I have my HVAC system serviced?</h3>
                        <p>We recommend at least twice a year and that is why we offer our Exclusive Club Membership which
                            provides 2 clean and safety checks per year, discounts and much more.</p>
                        <hr />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FAQs;